import React, { useState } from "react";
import classNames from "classnames";

import Button from "../../components/Form/Button"

import { ajax } from "../../services/ajax";
import { api } from "../../constants";

export default props => {
  const { className, children, onLogout, ...rest } = props;
  const [loading, setLoading] = useState(false);
  return (
    <Button      
      onClick={
        () => {
          setLoading(true);
          ajax.post(api.endpoints.logout)
            .then(() => {
              onLogout();
            })
            .catch(() => {
              setLoading(false);
            })
        }
      }
      className={classNames(className, 'align-items-center btn btn-secondary btn-sm d-flex justify-content-center')}
      loading={loading}
      {...rest}
    >
      خروج
    </Button>
  )
}